<template>
  <section>
    <b-card title="Master KPI">
      <b-tabs pills fill>
        <b-tab active>
          <template #title>
            <feather-icon icon="ListIcon" />
            <span>List KPI</span>
          </template>
        </b-tab>
        <b-tab @click="link('kpi-category')">
          <template #title>
            <feather-icon icon="FileIcon" />
            <span>Category</span>
          </template>
        </b-tab>
      </b-tabs>
    </b-card>
    <b-card>
      <!-- <b-card-text>KPI.</b-card-text> -->
      <b-link :to="{ path: '/kpi/add' }">
      <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary">
        <feather-icon icon="PlusIcon" /> Create KPI
      </b-button>  
      </b-link>
      <div><div class="h-50 d-inline-block"></div></div>
      <!-- input search -->
      <div class="custom-search d-flex justify-content-end">
        <b-form-group>
          <div class="d-flex align-items-center">
            <label class="mr-1">Search</label>
            <b-form-input v-model="searchTerm" placeholder="Search" type="text" class="d-inline-block"/>
          </div>
        </b-form-group>
      </div>
      <!-- table -->
      <vue-good-table :columns="columns" :rows="rows" :rtl="direction" :pagination-options="{ enabled: true, perPage:pageLength }" :search-options="{ enabled: true, externalQuery: searchTerm }" theme="my-theme">
        <template slot="table-row" slot-scope="props" >
          <span v-if="props.column.field === 'fullName'" class="text-nowrap">
            <b-avatar :src="props.row.avatar" class="mx-1" />
            <span>{{ props.row.fullName }}</span>
          </span>
          <!-- Column: status -->
          <span v-else-if="props.column.field === 'status'">
            <b-badge :variant="statusVariant(props.row.status)">
              <!-- {{ props.row.status }} -->
              Active
            </b-badge>
          </span>
          <!-- Column: Action -->
          <span v-else-if="props.column.field === 'action'">
            <span>
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template v-slot:button-content>
                  <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
                </template>
                <b-dropdown-item>
                  <b-link :to="{ path: '/kpi/detail/'+ props.row.id}">
                  <feather-icon icon="Edit2Icon" class="mr-50" />
                  <span>Edit</span>
                  </b-link>
                </b-dropdown-item>
                <b-dropdown-item>
                  <b-link v-b-modal.modal-center
                  @click="rowOnDelete(props.row.id)">
                  <feather-icon icon="TrashIcon" class="mr-50" />
                  <span>Delete</span>
                  </b-link>
                </b-dropdown-item>
              </b-dropdown>
            </span>
          </span>
          <!-- Column: Action -->
          <span v-else-if="props.column.field === 'date_start'">
            <span>
              {{ formatDate(props.row.date_start) }}
            </span>
          </span>
          <span v-else-if="props.column.field === 'date_finish'">
            <span>
              {{ formatDate(props.row.date_finish) }}
            </span>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <!-- page length -->
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap "> Showing 1 to </span>
              <b-form-select v-model="pageLength" :options="pages" class="mx-1" @input="(value)=>props.perPageChanged({currentPerPage:value})"/>
              <span class="text-nowrap"> of {{ props.total }} entries </span>
            </div>

            <!-- pagination -->
            <div>
              <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value)=>props.pageChanged({currentPage:value})" >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>
    </b-card>
  </section>
</template>

<script>
import { BCard, BCardText, BCardTitle, BTabs, BTab, BLink,  BButton, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BRow, BCol, BDropdown, BDropdownItem } from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import { formatDate } from '@core/utils/filter'
import { mapState } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store/index'
import router from '@/router/index.js'

export default {
  components: {
    VueGoodTable,
    BCardText, 
    BCardTitle,
    BTabs,
    BTab,
    BLink, 
    BButton,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    ToastificationContent,
    BCard,
    BDropdown,
    BDropdownItem
  },
  data () {
    return {
      dir: false,
      pageLength: 10,
      searchTerm: '',
      status:[
        { 1: 'Active', 2: 'Professional', 3: 'Rejected', 4: 'Resigned', 5: 'Applied' },
        { 1: 'light-success', 2: 'light-primary', 3: 'light-danger', 4: 'light-warning', 5: 'light-info' }
      ]
    }
  },
  computed: {
    ...mapState({ rows: state => state.kpi.all, columns: state => state.kpi.columns, pages: state => state.kpi.pages }),
    statusVariant () {
      const statusColor = { AC : 'light-success', Professional : 'light-primary', Rejected : 'light-danger', Resigned : 'light-warning', Applied : 'light-info' }
      return status => statusColor[status]
    },
    statusTextVariant () {
      const statusTextColor = {
        AC : 'light-success', Professional : 'light-primary', Rejected : 'light-danger', Resigned: 'light-warning', Applied: 'light-info'
      }
      return status => statusTextColor[status]
    },
    direction () {
      if (store.state.appConfig.isRTL) {
        this.dir = true
        return this.dir
      }
      this.dir = false
      return this.dir
    }
  },
  methods: {
    formatDate,
    link (link) {
      router.push({ name: link })
    },
    advanceSearch (val) {
      this.searchTerm = val
    },
    rowOnDelete (id) {
      this.$bvModal
      .msgBoxConfirm('Please confirm that you want to delete everything.', {
        title: 'Please Confirm', size: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'No', cancelVariant: 'outline-secondary', hideHeaderClose: false, centered: true,
      })
      .then(value => {
        if (value === true){
          this.$store.dispatch('kpi/remove', id)
          .then(response => {
            if (response.status === 200) {
              this.$store.dispatch('kpi/getAll')
              this.notification('Success','CheckIcon','success','You have successfully')
            } else {
              this.notification('Failed','CloseIcon','danger','You have unsuccessful')
            }
          },
          error => {
            this.notification('Failed','CloseIcon','danger','You have unsuccessful')
          }) 
        }
      })
    },
    notification (a,b,c,d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: { title: a, icon: b, variant: c, text: d}
      })
    }
  },
  directives: {
    Ripple
  },
  created () {
    this.$store.dispatch('kpi/getAll')
  }
}
</script>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>